$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.common_faq_questions');
  if (!node) { return; }

  $('article.common_faq_questions .question').on('click', ({ currentTarget }) => {
    $(currentTarget).toggleClass('is-active');
  });
});
